export enum NodeCategory {
  RESOURCE = 'RESOURCE',
  MODEL_CONCEPT_CLASS = 'MODEL_CONCEPT_CLASS',

  DELETED_RESOURCE = 'DELETED_RESOURCE',
  DELETED_MODEL_CONCEPT_CLASS = 'DELETED_MODEL_CONCEPT_CLASS',
}

export enum LinkLabelCategory {
  MAPPING_LABEL = 'MAPPING_LABEL',
  MODEL_CONCEPT_RELATIONSHIP_LABEL = 'MODEL_CONCEPT_RELATIONSHIP_LABEL',
  MODEL_CONCEPT_HIERARCHY_LABEL = 'MODEL_CONCEPT_HIERARCHY_LABEL',

  DELETED_MAPPING_LABEL = 'DELETED_MAPPING_LABEL',
  DELETED_MODEL_CONCEPT_RELATIONSHIP_LABEL = 'DELETED_MODEL_CONCEPT_RELATIONSHIP_LABEL',
  DELETED_MODEL_CONCEPT_HIERARCHY_LABEL = 'DELETED_MODEL_CONCEPT_HIERARCHY_LABEL',
}

export enum LinkCategory {
  MAPPING = 'MAPPING',
  MODEL_CONCEPT_RELATIONSHIP = 'MODEL_CONCEPT_RELATIONSHIP',
  MODEL_CONCEPT_HIERARCHY = 'MODEL_CONCEPT_HIERARCHY',
  RELATIONSHIP_MAPPING = 'RELATIONSHIP_MAPPING',

  DELETED_MAPPING = 'DELETED_MAPPING',
  DELETED_MODEL_CONCEPT_RELATIONSHIP = 'DELETED_MODEL_CONCEPT_RELATIONSHIP',
  DELETED_MODEL_CONCEPT_HIERARCHY = 'DELETED_MODEL_CONCEPT_HIERARCHY',
  DELETED_RELATIONSHIP_MAPPING = 'DELETED_RELATIONSHIP_MAPPING',
}

export enum HiddenCategory {
  NOT_HIDDEN = 'NOT_HIDDEN',
  MODEL_CONCEPT_ATTRIBUTE = 'MODEL_CONCEPT_ATTRIBUTE',
}
